import { ReactNode, useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, CircularProgress, TextField, Alert,
} from "@mui/material";

interface Props {
  open:      boolean;
  title:     string;
  children:  ReactNode;           // cuerpo (puede tener <b>)
  okLabel:   string;
  busyLabel?: string;
  danger?:   boolean;
  /** Si se pasa, el botón OK solo se habilita cuando el usuario tipea exactamente este texto. */
  typeToConfirm?: string;
  onClose:   () => void;
  onConfirm: () => Promise<void> | void;
}

/**
 * Confirmación estándar (patrón Whitelist/Access): título verbo + texto con la
 * entidad en negrita + Cancel + botón contained (error si destructivo).
 */
export default function ConfirmDialog({
  open, title, children, okLabel, busyLabel, danger, typeToConfirm, onClose, onConfirm,
}: Props) {
  const [busy, setBusy]   = useState(false);
  const [typed, setTyped] = useState("");
  const [err, setErr]     = useState<string | null>(null);
  useEffect(() => { if (open) { setTyped(""); setBusy(false); setErr(null); } }, [open]);

  // El error se muestra ACÁ, no en un toast detrás del diálogo: si la acción
  // falla el usuario tiene que verlo sin cerrar nada.
  async function go() {
    setBusy(true); setErr(null);
    try { await onConfirm(); }
    catch (e: any) { setErr(String(e?.message ?? e)); }
    finally { setBusy(false); }
  }
  const gated = !!typeToConfirm && typed.trim() !== typeToConfirm;

  return (
    <Dialog open={open} onClose={() => !busy && onClose()} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{children}</DialogContentText>
        {err && <Alert severity="error" sx={{ mt: 2 }}>{err}</Alert>}
        {typeToConfirm && (
          <TextField size="small" fullWidth autoFocus sx={{ mt: 2 }} value={typed} disabled={busy}
            label={`Type ${typeToConfirm} to confirm`} onChange={(e) => setTyped(e.target.value)}
            inputProps={{ autoComplete: "off" }} />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button variant="contained" color={danger ? "error" : "primary"} onClick={go} disabled={busy || gated}
          startIcon={busy ? <CircularProgress size={14} color="inherit" /> : undefined}>
          {busy ? (busyLabel ?? okLabel) : okLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
